// Mock data for Wrappus clone
export const LOGO_FULL = 'https://customer-assets-4nw71qhi.emergentagent.net/job_images-141/artifacts/1c9dcdf9_logo%20final%20Red.png';
export const LOGO_MARK = 'https://customer-assets-4nw71qhi.emergentagent.net/job_images-141/artifacts/vfr5r7bz_red.png';
export const LOGO_WHITE = 'https://customer-assets-4nw71qhi.emergentagent.net/job_images-141/artifacts/yjz33wez_logo%20final%20white%201%281%29.png';

export const NAV_LINKS = [
  { name: 'About', path: '/about' },
  { name: 'FAQs', path: '/faqs' },
  { name: 'Contact', path: '/contact' },
  { name: 'Franchising', path: '/franchising' },
];

export const ORDER_URL = 'https://wrappus.brygid.online/';

export const HERO_SLIDES = [
  {
    tag: 'REWARDS PROGRAM',
    emoji: '',
    title: 'EARN POINTS.\nGET FREE WRAPPUS',
    subtitle: 'Sign up and get 25 points free. Share your code, friends order — you earn 50 points.\nEvery $1 spent = 1 point. 100 points = $10 off.',
    cta: 'See Rewards',
    ctaTo: '/my-orders',
    image: 'https://wrappus.com/wp-content/uploads/2025/12/IMG_3572-scaled.jpg',
  },
  {
    tag: 'LIMITED TIME OFFER',
    emoji: 'party',
    title: 'Buy LARGE Signature DONAIR\n& GET A FREE SIDE',
    subtitle: 'Choose any FREE side item when you order a Large Signature Donair.',
    cta: 'Order Online',
    image: 'https://wrappus.com/wp-content/uploads/2026/08/aaabbbb.png',
  },
  {
    tag: 'TRULY CANADIAN',
    emoji: 'canada',
    title: 'CRAVING DONAIR?',
    subtitle: 'Freshly made wraps, poutines and platters — served hot and loaded.',
    cta: 'Order Online',
    image: 'https://wrappus.com/wp-content/uploads/2025/12/IMG_3699-scaled.jpg',
  },
  {
    tag: 'TRULY CANADIAN',
    emoji: 'canada',
    title: 'BIG FLAVOURS.\nBIGGER PORTIONS.',
    subtitle: 'Made fresh with quality ingredients and bold sauces you\u2019ll crave again & again.',
    cta: 'View Menu',
    image: 'https://wrappus.com/wp-content/uploads/2025/12/IMG_3572-scaled.jpg',
  },
  {
    tag: 'OPEN LATE · SERVING FAST',
    emoji: 'clock',
    title: 'Your permanent Donair\nSpot in Port Coquitlam',
    subtitle: 'Donairs • Wraps • Poutines • Platters — something for every appetite.',
    cta: 'Order Online',
    image: 'https://wrappus.com/wp-content/uploads/2025/12/IMG_3686-scaled.jpg',
  },
];

export const DEAL_CARDS = [
  {
    tag: 'Any Day, Any Time!',
    title: 'Daily Donair Deal. Just $7.99!',
    desc: 'No codes. No catch. Just hot, tasty wraps at the best price in town.',
    cta: 'Order Online',
    image: 'https://wrappus.com/wp-content/uploads/2026/08/pomelli_photoshoot-3.png',
  },
  {
    tag: 'Get Free Item!',
    title: 'Order Large Signature Donair, Get Free Side.',
    desc: 'Choose your Free Side Item when you order any Large Signature Donair.',
    cta: 'Grab It Now',
    image: 'https://wrappus.com/wp-content/uploads/2026/08/aaabbbb.png',
  },
];

export const GALLERY_IMAGES = [
  'https://wrappus.com/wp-content/uploads/2025/12/IMG_3699-scaled.jpg',
  'https://wrappus.com/wp-content/uploads/2025/09/Hummus-Bowl-Square-Shot.jpg',
  'https://wrappus.com/wp-content/uploads/2025/12/IMG_3572-scaled.jpg',
  'https://wrappus.com/wp-content/uploads/2025/12/IMG_3686-scaled.jpg',
];

export const OPENING_HOURS = [
  { day: 'Monday', time: '11am to 11pm' },
  { day: 'Tuesday', time: '11am to 11pm' },
  { day: 'Wednesday', time: '11am to 11pm' },
  { day: 'Thursday', time: '11am to 11pm' },
  { day: 'Friday', time: '11am to 12am' },
  { day: 'Saturday', time: '11am to 12am' },
  { day: 'Sunday', time: '11am to 11pm' },
];

export const HOURS_IMAGE = 'https://wrappus.com/wp-content/uploads/2025/12/IMG_3561-1024x1024.jpg';
export const YT_VIDEO_ID = 'qKEVouqizvg';
export const WRAPS_IMAGE = 'https://wrappus.com/wp-content/uploads/2026/08/pomelli_photoshoot_image_9_16_0505-8.png';
export const ABOUT_IMAGE = 'https://wrappus.com/wp-content/uploads/2026/08/pomelli_photoshoot_image_9_16_0504-53.png';
export const WHY_IMAGE = 'https://wrappus.com/wp-content/uploads/2025/08/Main-e1754115457721.jpg';

export const WHY_CHOOSE_US = [
  { title: 'Fresh, Flavor-Packed Food', desc: 'Every bite is crafted with fresh ingredients, bold spices, and made-to-order care. We don\u2019t just serve meals \u2014 we serve comfort.', icon: 'Utensils' },
  { title: 'Affordable for Everyone', desc: 'Great food shouldn\u2019t be a luxury. Our portions are generous, and our prices are honest. Grab a full meal without emptying your wallet.', icon: 'HandCoins' },
  { title: 'Friendly Staff, Fast Service', desc: 'Our team treats you like family \u2014 whether it\u2019s your first visit or your fiftieth. Quick service with a smile, every time.', icon: 'Handshake' },
  { title: 'Loyalty That Gives Back', desc: 'Earn 1 point for every $1 you spend online. That\u2019s 10% back in rewards for your next order!', icon: 'Gift' },
];

export const REVIEWS = [
  { name: 'Mahed Rafati', text: 'Super good service and donair' },
  { name: 'Katherine Butler', text: 'Finally a great donair spot on our side of poco… every bite was delicious' },
  { name: 'Alexandria Savitskoff', text: 'Good service, super friendly and great donairs!' },
  { name: 'Khale', text: 'Food is decent. Size ok not too big but quality decent.' },
  { name: 'Opinder Singh Harry', text: 'Good food really awesome. I suggest everyone to visit once for a good taste.' },
  { name: 'Bryan Vance', text: 'When I tell you I was excited to get a Donair place in the neighbourhood, you have no idea. Each one was super flavourful and unique. Great value for the price and grilled really well. Great that they stay open late.' },
  { name: 'Hyeonlee Jeong', text: 'Service was great, great price, everything was very clean. Masala falafel donair was great taste \u2014 crunch and balanced on sauce.' },
  { name: 'Tu Hung', text: 'Pretty good Beef Donair. One of the cleanest Donair shops I\u2019ve been to.' },
];

export const FAQS = [
  { q: 'What kind of meats do you serve?', a: 'We serve chicken, beef, lamb, and falafel options in our wraps, platters, and meals. *All meats are Halal, except for chicken wings, which are listed under our Sides category and are not Halal.' },
  { q: 'What are your hours of operation?', a: 'We\u2019re open every day from 11:00 AM to 11:00 PM on weekdays and 11:00 AM to 1:00 AM on weekends. Perfect for lunch, dinner, and those late-night cravings!' },
  { q: 'Do you have any ongoing deals or specials?', a: 'Yes! Every day, we offer Regular Donair (Chicken, Beef, Lamb, or Falafel) for just $7.99 + tax. Keep an eye on our home page and social media for more deals!' },
  { q: 'Do you have a loyalty or rewards program?', a: 'Absolutely! With every purchase, you earn points. Buy 7 meals through our website and get the 8th FREE — automatically tracked for you! (Valid only for online orders through website.)' },
  { q: 'Do you offer delivery?', a: 'Yes — and we deliver it ourselves! Order directly from Wrappus and get your meal faster, fresher, and at a better price. We\u2019re also on Uber Eats, DoorDash, and SkipTheDishes. Ordering direct supports local and saves you money!' },
  { q: 'Do you offer vegetarian or vegan options?', a: 'Yes, we offer Falafel wraps and platters, which are vegetarian. Vegan customers can choose sauces like Tahini or Hot Sauce with no cheese and confirm options with staff.' },
  { q: 'How spicy are your sauces?', a: 'You choose! We offer a range of sauces from garlic and tahini to hot/spicy and chipotle. Our team can customize it mild or wild — just let us know.' },
  { q: 'Do you offer drinks or combo meals?', a: 'Yes! You can pair your donair with Fries or Onion Rings, and Cans of Pops. Check our menu page for full details.' },
  { q: 'Where are you located?', a: '3353 Coast Meridian Rd, Port Coquitlam, BC V3B 3N6. We\u2019re working on expanding! Franchise inquiries welcome.' },
  { q: 'What payment methods do you accept?', a: 'We accept all possible payment types: Cash (in store), Credit & Debit Cards (VISA, Mastercard, Amex, etc.), and Mobile Payments (Apple Pay, Google Pay).' },
  { q: 'Are the chicken wings Halal?', a: 'No, chicken wings are not Halal. All other meat products (chicken, beef, lamb) are Halal.' },
];

export const CONTACT = {
  phone: '604 468 4133',
  phoneRaw: '+16044684133',
  email: 'info@wrappus.com',
  address: '3353 Coast Meridian Rd, Port Coquitlam, BC V3B 3N6',
  mapUrl: 'https://maps.app.goo.gl/P3qyheTXyhewR1FZ7',
  instagram: 'https://www.instagram.com/wrappus/',
  facebook: 'https://www.facebook.com/wrappus',
  youtube: 'https://www.youtube.com/@Wrappus',
};

export const ABOUT_FEATURES = [
  { tag: 'In-House Delivery', title: '30 Minutes or Less. Hot. Fast. Yours.', desc: 'Why wait on third-party apps? Get your donairs delivered directly from our kitchen in 30 minutes or less. Our in-house delivery means lower fees, hotter food, and better service — every time.', icon: 'Bike' },
  { tag: 'Fast Takeout, Always Ready', title: 'Grab & Go Made Easy.', desc: 'Everyday hustle? We\u2019ve got you. Order ahead or walk in — your rice plates, loaded poutines, donairs or just fries. All packed fast and fresh, ready when you are. Quick. Clean. Reliable.', icon: 'ShoppingBag' },
  { tag: 'Catering for All Occasions', title: 'From Parties to Office Lunches.', desc: 'Planning an event? We bring the flavor to your celebration. With customizable catering packages, our team delivers fresh, crowd-pleasing meals that\u2019ll leave your guests raving.', icon: 'PartyPopper' },
  { tag: 'Affordable Everyday', title: '$7.99 Daily Deal', desc: 'You shouldn\u2019t have to break the bank for a great meal. That\u2019s why our $7.99 daily deal is here for you — every single day. Big flavor, small price.', icon: 'Tag' },
  { tag: 'Locally Owned & Operated', title: 'Made in Port Coquitlam. Loved by Port Coquitlam.', desc: 'Wrappus Donair isn\u2019t a chain — it\u2019s a neighborhood spot built by locals, for locals. Supporting us means supporting your community.', icon: 'MapPin' },
  { tag: 'We\u2019re Open until 12 AM.', title: 'Late Night Cravings?', desc: 'Midnight hunger is real and we respect that. Whether it\u2019s 12 AM or lunchtime, we\u2019re here serving up hot, satisfying meals when you need them most.', icon: 'Moon' },
];

export const FRANCHISE_BENEFITS = [
  { icon: 'Flag', title: 'Proudly Canadian. Built for Canadians.', desc: 'Born in the heart of Coquitlam, Wrappus reflects Canada\u2019s multicultural appetite — with Mediterranean flavours, Canadian comfort, and late-night eats everyone craves. We don\u2019t just feed the community — we\u2019re part of it.' },
  { icon: 'Wrench', title: 'Turnkey Setup. Real Results.', desc: 'We\u2019ve done the groundwork so you don\u2019t have to. From training and supply chain to branding and delivery integrations — you get a full system designed for fast onboarding and high efficiency.' },
  { icon: 'Users', title: 'You\u2019re Family Here.', desc: 'Our franchisees aren\u2019t just business partners — they\u2019re part of our Wrappus family. We grow together, we support each other, and we celebrate every milestone as one team. Your success is our success.' },
  { icon: 'Brain', title: 'Local Business, Smart Systems.', desc: 'We blend the flexibility of small business ownership with the power of a refined system. Digital POS, third-party delivery, online marketing kits, staff training modules — we provide the modern tools to help you thrive.' },
  { icon: 'Zap', title: 'Brand Power Meets Everyday Affordability.', desc: 'From our Signature wraps and rice plates to our $7.99 Daily Deal and late-night hours — Wrappus hits where it matters: flavour, price, and convenience. Customers love it. You\u2019ll love the margins.' },
];

export const FRANCHISE_PACKAGE = [
  'Complete Training for You & Team',
  'Operational Playbooks & Support',
  'Supplier & Recipe Access',
  'POS System + Digital Tools',
  'Launch Marketing Toolkit',
  'Site & Interior Guidelines',
  'Protected Territory Rights*',
];
